<div class="copyright">
  <div class="copyright-text">
    <span>{{ 'bcCopyright.copyright' | translate }}</span>
    <span>© {{ startYear }}-{{ currentYear }} </span>
    <span>{{ 'bcCopyright.incorporation' | translate }}</span>
    <span>{{ 'bcCopyright.rights' | translate }}</span>
  </div>
</div>
